import React from 'react';
import Button from '../../../Components/button';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';


const Colegios: React.FC<{buttonText: string, buttonLink: string, parceiros: Array<{ imagem: string }>}> = ({buttonText, buttonLink, parceiros}) => {
    return (
        <section className='py-8 max-w-[1920px] mx-auto px-4'>
            <h3 className="text-2xl font-semibold text-center text-balance">
                Conheça os <span className='text-main-pink'>colégios parceiros</span> <br />
                da Uniexpo
            </h3>

            <Swiper className='relative'>
                {Array.from({ length: 1 }, (_, index) => (
                    <SwiperSlide key={index}>
                        <div className="flex justify-center gap-6 mt-8">
                        {parceiros.map((parceiro, index) => (
                            <div key={index} className="max-w-[200px] flex justify-center items-center">
                                <img  src={parceiro.imagem} alt={`Colégio ${index}`} className="w-full object-contain h-auto py-2 px-4" />
                            </div>
                        ))}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="mt-8 md:mt-14 grid md:grid-cols-3 gap-8 md:after:content-[''] md:before:content-[''] max-w-screen-lg mx-auto">
                {buttonText &&
                    <Button target='_blank' text={buttonText} link={buttonLink} arrow={false} color="pink" />
                }
            </div>
        </section>
    );
};

export default Colegios;